<template>
  <div class="design-choice h-100">

    <!-- <div class="col-container d-flex"> -->
      <!-- <div class="w-50 shadow-box py-2 pb-2 mr-1 bg-light"> -->
      <!-- <div class="shadow-box py-2 pb-2 mr-1 bg-light mt-2"> -->
      <div class="py-2 pb-2 bg-light h-100">
        <template v-if="activeCategory == 'Gravsten'">
          <h2 class="mb-0 py-2 text-center pt-3">Designa gravsten</h2>
          <p class="py-2 text-center mb-2">Välj vilken typ av gravsten ni vill ha och skapa den utefter era önskemål.</p>
        </template>
        <template v-if="activeCategory == 'Text'">
          <h2 class="mb-0 py-2 text-center pt-3">Text och typsnitt</h2>
          <p class="py-2 text-center mb-2">Välj text, utförande, typsnitt, färg och om rader ska lämnas till framtiden.</p>
        </template>
        <template v-if="activeCategory == 'Dekor'">
          <h2 class="mb-0 py-2 text-center pt-3">Dekor</h2>
          <p class="py-2 text-center mb-2">Välj upp till två dekorer och dess färg.</p>
        </template>
        <template v-if="activeCategory == 'Tillval'">
          <h2 class="mb-0 py-2 text-center pt-3">Gör tillval</h2>
          <p class="py-2 text-center mb-2">Här väljer ni om ni vill ha några tillval till gravstenen. Tillvalen specificeras och läggs på slutsumman.</p>
        </template>


        <div class="category-bar mt-2">
           <div
            v-for='(category, index) in categories'
            :class="'category-bar-item ' + (activeCategory == category ? 'active' : '')"
            :key="index"
            @click="chooseCategory(category)"
          >
            {{ category }}
          </div>
        </div>
        <div :class="'category-container ' + (activeCategory == 'Gravsten' ? 'active' : '')">
          <h4 class="mt-2">Gravsten</h4>
          <div class="flex-start mb-15">
            <label class="form-control mr-1">
              <input  @change="setOrientation($event)" type="radio" name="gravestone" value="standing" v-model="gravestone_orientation" checked />
              Stående
            </label>
            <label class="form-control">
              <input @change="setOrientation($event)" type="radio" name="gravestone" value="lying" v-model="gravestone_orientation"  />
              Liggande
            </label>
          </div>
           <SelectGravestone
            v-if="gravestones.length"
            :options="gravestones"
            :default="selectedGravestone"
            class="select mt-1"
            :selectGravestone="selectGravestone"
          />

          <template v-if="selectedGravestone.has_edging || selectedGravestone.is_edging">
             <div class="flex-start mt-05">
              <label class="form-control mr-1">
                <input  @change="selectWithboard($event, selectedGravestone.is_edging)" type="radio" name="withboard" value="0" v-bind:checked="withboard == 0" />
                Utan bård
              </label>
              <label class="form-control">
                <input @change="selectWithboard($event, selectedGravestone.is_edging)" type="radio" name="withboard" value="1" v-bind:checked="withboard == 1" />
                Med bård
              </label>
            </div>
          </template>
          <h4 class="mt-2">Storlek</h4>
          <SelectStonesize
            v-if="stonesizes.length"
            :options="stonesizes"
            :selected="selectedStonesize"
            class="select"
            :selectStonesize="selectStonesize"
          />

          <h4 class="mt-2">Stensort</h4>
          <SelectStonetype
            :options="stonetypes"
            :selected="selectedStonetype"
            class="select"
            :selectStonetype="selectStonetype"
          />
          <div class="mt-05">
            <a class="bold" target="_blank" href="https://www.orsasten.se/wp-content/uploads/2022/04/Färgval-på-olika-stensorter.pdf">Exempel textfärg/stensort</a>
          </div>

          <h4 class="mt-2">Utförande</h4>
          <h5 class="mt-1">Polerad eller finhuggen textyta (sågad sockel)</h5>
           <div class="flex-start">
            <label
              v-for="(treatment, i) of surfacetreatments"
              :key="i"
              class="form-control mr-1">
              <input  @change="selectSurfacetreatment($event)" type="radio" name="surfacetreatments" :value="treatment"  v-bind:checked="treatment === selectedSurfacetreatment"/>
              {{ treatment }}
            </label>
          </div>

          <template v-if="selectedGravestone.has_edge_treatment_option">
          <h5 class="mt-2">Sågad eller råhuggen kant (sågad sockel)</h5>
           <div class="flex-start">
            <label
              v-for="(treatment, i) of edgetreatments"
              :key="i"
              class="form-control mr-1">
              <input  @change="selectEdgetreatment($event)" type="radio" name="edgetreatments" :value="treatment"  v-bind:checked="treatment === selectedEdgetreatment"/>
              {{ treatment }}
            </label>
          </div>
          </template>

      <!--     <SelectSurfacetreatment
            :options="surfacetreatments"
            :default="selectedSurfacetreatment"
            class="select mt-1"
            :selectSurfacetreatment="selectSurfacetreatment"
          />
       -->

        </div>

        <div :class="'category-container ' + (activeCategory == 'Text' ? 'active' : '')">


          <h4 class="mt-2" style="display: flex;">Skriv egen text<div class="tooltip" style="margin-left: 10px;"><svg version="1.1" width="20px" height="20px" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 29.536 29.536" style="enable-background:new 0 0 29.536 29.536;" xml:space="preserve"><g><path d="M14.768,0C6.611,0,0,6.609,0,14.768c0,8.155,6.611,14.767,14.768,14.767s14.768-6.612,14.768-14.767
    C29.535,6.609,22.924,0,14.768,0z M14.768,27.126c-6.828,0-12.361-5.532-12.361-12.359c0-6.828,5.533-12.362,12.361-12.362
    c6.826,0,12.359,5.535,12.359,12.362C27.127,21.594,21.594,27.126,14.768,27.126z"/><path d="M14.385,19.337c-1.338,0-2.289,0.951-2.289,2.34c0,1.336,0.926,2.339,2.289,2.339c1.414,0,2.314-1.003,2.314-2.339
    C16.672,20.288,15.771,19.337,14.385,19.337z"/><path d="M14.742,6.092c-1.824,0-3.34,0.513-4.293,1.053l0.875,2.804c0.668-0.462,1.697-0.772,2.545-0.772
    c1.285,0.027,1.879,0.644,1.879,1.543c0,0.85-0.67,1.697-1.494,2.701c-1.156,1.364-1.594,2.701-1.516,4.012l0.025,0.669h3.42
    v-0.463c-0.025-1.158,0.387-2.162,1.311-3.215c0.979-1.08,2.211-2.366,2.211-4.321C19.705,7.968,18.139,6.092,14.742,6.092z"/>
  <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
</svg><span class="tooltiptext"><span class="bold" style="font-size: 14px;">Extra symboler:</span><br><span>Kors = +</span><br><span>Stjärna = *</span></span></div></h4>
          <span class="font-italic">För text över 40 tecken tillkommer kostnad på 90kr/taecken.</span>
          <div class="selected-text-container">
            <div
              class="item w-100 text-container"
              v-for="(text, i) of selectedTexts"
              :key="i"
            >
              <div class="d-flex py-05 between">
                <div @click="updateText(text, 'delete')" class="close"></div>
                <div class="w-auto d-flex">
                  <span>Storlek: {{ Math.round(text.fontSize) }}</span>
                  <font-awesome-icon
                    @click="updateText(text, 'increase-size')"
                    class="fontawesome-icon"
                    :icon="['fas', 'plus']"
                  />
                  <font-awesome-icon
                    @click="updateText(text, 'decrease-size')"
                    class="fontawesome-icon"
                    :icon="['fas', 'minus']"
                  />
                  <font-awesome-icon
                    @click="updateText(text, 'align-left')"
                    class="fontawesome-icon"
                    :icon="['fas', 'align-left']"
                  />
                  <font-awesome-icon
                    @click="updateText(text, 'align-center')"
                    class="fontawesome-icon"
                    :icon="['fas', 'align-center']"
                  />
                </div>
              </div>
              <div class="input-container mb-1">
                <textarea style="resize: none;" :class="'input-container text-input mb-1 text-' + text.align + '-important'" @input="updateText(text, 'text', $event)" :id="'inscription' + i" :value="text.text"></textarea>
              </div>
            </div>
          </div>
          <div @click="addTextField()" class="button">Lägg till textruta</div>
          <h4 class="mt-2">Välj text-/dekorutförande</h4>
          <SelectInscriptiondesign
            :options="inscriptiondesigns"
            :selected="selectedInscriptiondesign"
            class="select"
            :selectedSurfacetreatment="selectedSurfacetreatment"
            :selectInscriptiondesign="selectInscriptiondesign"
            :orientation="gravestone_orientation"
          />

          <h4 class="mt-2">Välj teckensnitt</h4>
          <SelectFont
            v-if="fonts.length"
            :options="fonts"
            :selected="selectedFont"
            class="select"
            :selectFont="selectFont"
          />

          <template v-if="selectedInscriptiondesign.name == 'Försänkt målad'">
            <h4 class="mt-2">Färg - Textfärg</h4>
            <SelectColor
              :options="colors"
              :default="selectedTextColor"
              class="select"
              :selectColor="selectColor"
              type="text"
            />
            <div class="mt-05">
              <a class="bold" target="_blank" href="https://www.orsasten.se/wp-content/uploads/2022/04/Färgval-på-olika-stensorter.pdf">Exempel textfärg/stensort</a>
            </div>
          </template>


          <h4 class="mt-2">Lämna rader inför framtiden (antal rader)</h4>
          <div class="input-container mb-1">
            <input @change="updateReserverows($event)" :value="reserverows" pattern="[0-9]" min="0" max="10" id="inscription_reserved_rows" type="number" />
          </div>
        </div>
        <div :class="'category-container ' + (activeCategory == 'Dekor' ? 'active' : '')">
          <h4 class="mt-2">Lägg till dekor</h4>
          <div class="selected-decors-container mb-2" >
            <div
              class="item image-container"
              v-for="(decor, i) of selectedDecors"
              :key="i"
            >
              <div
              class="close"
              @click="deleteDecor(decor)"
              ></div>
              <div>
                <div  @click="flipDecor(decor)"  class="mirror-button">Spegelvänd</div>
             <!--      <font-awesome-icon
                  @click="flipDecor(decor)"
                  class="fontawesome-icon"
                  :icon="['fa', 'arrow-right']"
                />

                <font-awesome-icon
                  @click="flipDecor(decor)"
                  class="fontawesome-icon"
                  style="rotate('90deg')"
                  :icon="['fa', 'minus']"
                />
                   <font-awesome-icon
                  @click="flipDecor(decor)"
                  class="fontawesome-icon"
                  :icon="['fa', 'arrow-left']"
                />
                -->
              </div>



              <img style="" :alt="decor.name" :src="getPic(decor.file_name)">
            </div>
          </div>

          <SelectDecor
            v-if="decors"
            :options="decors"
            :selected="decors['Växter'][0]"
            class="select"
            :addDecor="addDecor"
            :amountSelected="selectedDecors.length"
          />
          <template v-if="selectedInscriptiondesign.name == 'Försänkt målad'">
            <h4 class="mt-2">Färg - Dekorfärg</h4>
            <SelectColor
              :options="colors"
              :default="selectedDecorColor"
              class="select"
              :selectColor="selectColor"
              type="decor"
            />
          </template>
        </div>
        <div :class="'category-container ' + (activeCategory == 'Tillval' ? 'active' : '')">
          <h4 class="mt-2">Tillval</h4>

          <SelectAccessories
            :options="accessories.accessories"
            :default="accessories.accessories[0]"
            class="select"
            :selectAccessories="selectAccessories"
            :selectedStonesize="selectedStonesize"
            :percentageIncrease="percentageIncrease"
            :orientation="orientation"
          />
          <!-- <h4 class="mt-2">Övrigt</h4> -->
            <SelectAccessories
            :options="accessories.other"
            :default="accessories.other[0]"
            class="select"
            :selectAccessories="selectAccessories"
            :selectedStonesize="selectedStonesize"
          />
          <h4 class="mt-2">Tillagt</h4>
          <template v-if="selectedAccessories.length">
             <div class="selected-accessories-container">
              <div
                class="item border-grey image-container mb-1 d-flex"
                v-for="(accessories, i) of selectedAccessories"
                :key="i"
              >
                <div
                class="close-accossieries"
                @click="deleteAccessorie(accessories)"

                ></div>
                <img class="pa-05" style="width: 75px;" :alt="accessories.name" :src="getAccPic(accessories.file_name)">
                <div class="ml-05">
                  <span class="font-size-1">{{ accessories.name }}</span><br>
                  <span>{{ formatPrice((accessories.name == 'Blomlist' ? accessories.priceInclVat * percentageIncrease : accessories.priceInclVat)) }} kr</span>
                </div>

              </div>
            </div>
          </template>
        </div>
      </div>
  </div>
</template>

<script>
import SelectGravestone from "./SelectGravestone.vue";
import SelectStonesize from "./SelectStonesize.vue";
import SelectDecor from "./SelectDecor.vue";
import SelectFont from "./SelectFont.vue";
import SelectStonetype from "./SelectStonetype.vue";
import SelectInscriptiondesign from "./SelectInscriptiondesign.vue";
import SelectColor from "./SelectColor.vue";
import SelectAccessories from "./SelectAccessories.vue";

export default {
  name: 'DesignStep',
  components: {
    SelectGravestone,
    SelectStonesize,
    SelectDecor,
    SelectFont,
    SelectStonetype,
    SelectInscriptiondesign,
    SelectColor,
    SelectAccessories
  },
  props: {
    chooseStep: Function,

    orientation: String,
    setOrientation: Function,

    gravestones: Array,
    selectedGravestone: Object,
    selectGravestone: Function,

    stonesizes: Object,
    selectStonesize: Function,
    selectedStonesize: Object,

    withboard: Number,
    selectWithboard: Function,

    decors: Object,
    selectedDecors: Array,
    addDecor: Function,
    deleteDecor: Function,
    flipDecor: Function,

    fonts: Array,
    selectedFont: Object,
    selectedTexts: Array,
    selectFont: Function,

    addText: Function,
    updateText: Function,

    stonetypes: Array,
    selectedStonetype: Object,
    selectStonetype: Function,

    surfacetreatments: Array,
    selectedSurfacetreatment: String,
    selectSurfacetreatment: Function,

    edgetreatments: Array,
    selectEdgetreatment: Function,
    selectedEdgetreatment: String,

    inscriptiondesigns: Array,
    selectedInscriptiondesign: Object,
    selectInscriptiondesign: Function,

    colors: Array,
    selectedTextColor: Object,
    selectedDecorColor: Object,
    selectColor: Function,

    reserverows: Number,
    updateReserverows: Function,

    accessories: Array,
    selectedAccessories: Array,
    selectAccessories: Function,
    deleteAccessorie: Function,

    percentageIncrease: Number
  },
  data () {
    return {
      gravestone_orientation: 'standing',
      allGravestones: [],
      categories: ['Gravsten', 'Text', 'Dekor', 'Tillval' ],
      activeCategory: 'Gravsten'
    }
  },
  mounted() {
    this.gravestone_orientation = this.orientation;
  },
  methods: {
    getPic(file_name) {
      return process.env.VUE_APP_IMAGE_FOLDER + '/dekorer/' + file_name;
    },
    getAccPic(file_name) {
      return process.env.VUE_APP_IMAGE_FOLDER + 'tillbehör/' + file_name;
    },
    addTextField() {
      this.addText();
      setTimeout(() => {
        let order_rows_last_inputs = document.querySelectorAll('.text-input');
        let order_rows_last_input = order_rows_last_inputs[order_rows_last_inputs.length - 1];

        order_rows_last_input.focus();
      }, 100);
    },
    chooseCategory(category) {
      this.activeCategory = category;
    },
    formatPrice(x) {
       return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .design-choice {
    min-height: 400px;
  }

  .mirror-button {
    position: absolute;
    background: #0d564c;
    width: 100%;
    text-align: center;
    color: #fff;
    bottom: -15px;
    cursor: pointer;
    transition: 0.2s all;
    z-index: 100;
        padding: 5px;
  }

  .mirror-button:hover {
    opacity: 0.8;
  }

  .category-bar {
    height: 40px;
    line-height: 41px;
    background-color: #c3d2d0;
    color: #fff;
    display: -webkit-flex;
    display: flex;
    text-transform: uppercase;
    white-space: nowrap;
    justify-content: space-between;
  }
  .category-bar-item {
    text-align: center;
    width: 100%;
    font-weight: bolder;
    font-size: 1rem;
    cursor: pointer;
    transition: 0.2s all;
  }

  .category-bar-item:hover {
    background: #487b74;
  }

  .category-bar-item.active {
    background: #0c564c;
    box-shadow: 0 2px 12px 5px rgb(0 0 0 / 15%);
  }

  .category-container {
    display: none;
  }

  .category-container.active {
    display: block;
  }

  @media only screen and (max-width: 600px) {
    .category-bar {
      flex-direction: column;
      height: auto;
    }
  }

  .flex-start {
    display: flex;
    justify-content: start;
    align-items: baseline;
  }

  .example-select {
    width: 100%;
    height: 60px;
    background: #fff;
    border: 1px solid #a5a5a5;
    cursor: pointer;
  }

  .example-select:hover {
    cursor: pointer;
  }

.form-control {
  font-family: system-ui, sans-serif;
  font-size: 1rem;
  line-height: 1.1;
  display: grid;
  grid-template-columns: 1em auto;
  gap: 0.5em;
}

.form-control + .form-control {
  margin-top: 1em;
}

.form-control:focus-within {
  color: var(--form-control-color);
}

input[type="radio"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--form-background);
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 50%;
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--form-control-color);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

/************ DECORS ************/
.selected-decors-container {
  display:flex;

}

.selected-decors-container .image-container {
  width: 30%;
  max-width: 110px;
  position: relative;
  height: fit-content;
  border: 1px solid transparent;
  transition: 0.1s all;
}

.selected-decors-container .image-container:hover {
  /*background: #ffffff4a;
  border: 1px solid #e9e9e9;*/
}

.selected-decors-container img {
  padding: 1rem;
  max-width: 100%;
  max-height: 100%;
}

.selected-text-container .text-container {
  position: relative;
}

.selected-text-container .close {
  position: initial;
}

.close {
  position: absolute;
  font-size: 2rem;
  top: 10px;
  left: 10px;
  color: red;
  transition: 0.1s all;
}

.close:hover,
.fontawesome-icon:hover {
  opacity: 0.5;
}

.close:after {
  cursor: pointer;
  display: inline-block;
  content: "\00d7"; /* This will render the 'X' */
}

.fontawesome-icon {
  font-size: 1.5rem;
  margin-left: 1rem;
  cursor: pointer;
  transition: 0.1s all;
}

#inscription_reserved_rows {
  padding: 1rem !important;
}

 .design-choice {
    min-height: 400px;
  }

  .selected-accessories-container {
    /*display:flex;*/
  }

  .selected-accessories-container .image-container {
    align-items: center;
    background: #fff;
    /*border: 1px solid #e9e9e9;*/
    position: relative;
    height: fit-content;
    /*border: 1px solid transparent;*/
    transition: 0.1s all;
  }

  .selected-accessories-container .image-container:hover {
    /*background: #ffffff4a;
    border: 1px solid #e9e9e9;*/
  }

  .selected-accessories-container img {
    max-width: 100%;
    max-height: 100%;
  }

  .close-accossieries {
    position: absolute;
    font-size: 2rem;
    top: 10px;
    right: 10px;
    color: red;
    transition: 0.1s all;
  }

  .close-accossieries:hover,
  .fontawesome-icon:hover {
    opacity: 0.5;
  }

  .close-accossieries:after {
    cursor: pointer;
    display: inline-block;
    content: "\00d7"; /* This will render the 'X' */
  }

  .tooltip .tooltiptext {
      visibility: hidden;
    width: 145px;
    color: #000;
    border-radius: 5px;
    position: absolute;
    z-index: 1;
    background: #ffffff;
    font-size: 1rem;
    font-weight: 400;
    padding: 7px 12px;
    font-size: 14px;
    border: 2px solid #0d564c;
    margin-left: 5px;
    font-size: 13px;
  }

  .tooltip .tooltiptext span {

  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }



</style>
